import React from 'react';

import VistiSkipLinks from '@package/components/SkipLinks/SkipLinks';

const SkipLinks = () => {
  return <VistiSkipLinks />;
};

export default SkipLinks;
